import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';
import { generateCode } from 'pages/Discounts/utilities/generateCode';
import { FormField, FormItem, FormControl, FormMessage } from '@/components/ui/form';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { DiscountCodeZ as DiscountCode } from '@libs/schemas';

export const DiscountCodeFormField = () => {
  const form = useFormContext<DiscountCode>();
  const handleGenerateCode = useCallback(() => {
    const code = generateCode();
    form.setValue('code', code as string);
  }, []);
  return (
    <FormField
      control={form.control}
      name="code"
      render={({ field }) => (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Discount Code</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <FormItem>
              <div className="flex gap-2">
                <FormControl>
                  <Input placeholder="WELCOME20" className="font-mono" {...field} />
                </FormControl>
                <Button type="button" variant="outline" onClick={handleGenerateCode}>
                  Generate
                </Button>
              </div>
              <FormMessage />
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Use uppercase letters and numbers only. Minimum 3 characters.
              </p>
            </FormItem>
          </CardContent>
        </Card>
      )}
    />
  );
};
